module.exports = "img/flags/LU.dd87418.png";